export enum OptimizationType {
  asset = 'asset',
  portfolio = 'portfolio',
  yield = 'yield',
}
